<template>
    <div class="pallet">
        <button class="button-default main" @click="openPallet" >
            <img :src="edit_icon">
        </button>
        <transition name="fade">
            <div v-if="pallet" class="pallet-container">
                <ul>
                    <li v-for="(color, key) in newColor" :key="key">
                        <label :for="key" v-text="getString(key)"></label>
                        <input type="color" :id="key" :name="key" v-model="newColor[key]">
                    </li>
                </ul>
                <div class="footer">
                    <button class="button-default btn-outlined" @click="revert">{{ getString('reverter') }}</button>
                    <button class="button-default" @click="apply">{{ getString('aplicar') }}</button>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import ProdBloqsContainer from '@/components/ProdBloqsContainer'
import LocaleController from '@/assets/controllers/LocaleController'

export default {
    name: 'EditMode',
    components: {
        ProdBloqsContainer
    },
    data () {
        return {
            pallet: false,
            document: document.querySelector(':root'),
            edit_icon: require('../../static/icons/edit_white.svg'),
            config: Util.getLocalVar('taaconfig'),
            newColor: {
                primary_color: `${getComputedStyle(document.body).getPropertyValue('--primary-color')}`.trim(),
                primary_light: `${getComputedStyle(document.body).getPropertyValue('--primary-light')}`.trim(),
                primary_dark: `${getComputedStyle(document.body).getPropertyValue('--primary-dark')}`.trim(),
                header_color: `${getComputedStyle(document.body).getPropertyValue('--header-color')}`.trim(),
                categorie_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-color')}`.trim(),
                categorie_font_color: `${getComputedStyle(document.body).getPropertyValue('--categorie-font-color')}`.trim(),
                cart_color: `${getComputedStyle(document.body).getPropertyValue('--cart-color')}`.trim()
            },
            backupColor: {}
        }
    },
    mounted () {
        this.backupColor = Util.deepCopy(this.newColor)
    },
    watch: {
        newColor: {
            handler (newValue) {
                this.document.style.setProperty('--primary-color', newValue.primary_color)
                this.document.style.setProperty('--primary-light', newValue.primary_light)
                this.document.style.setProperty('--primary-dark', newValue.primary_dark)
                this.document.style.setProperty('--header-color', newValue.header_color)
                this.document.style.setProperty('--categorie-color', newValue.categorie_color)
                this.document.style.setProperty('--categorie-font-color', newValue.categorie_font_color)
                this.document.style.setProperty('--cart-color', newValue.cart_color)
            },
            deep: true
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        openPallet: function () {
            this.pallet = !this.pallet
            if (this.pallet) {
                this.edit_icon = require('../../static/icons/close_white.svg')
            } else {
                this.edit_icon = require('../../static/icons/edit_white.svg')
            }
        },
        revert: function () {
            this.document.style.setProperty('--primary-color', this.backupColor.primary_color)
            this.document.style.setProperty('--primary-light', this.backupColor.primary_light)
            this.document.style.setProperty('--primary-dark', this.backupColor.primary_dark)
            this.document.style.setProperty('--header-color', this.backupColor.header_color)
            this.document.style.setProperty('--categorie-color', this.backupColor.categorie_color)
            this.document.style.setProperty('--categorie-font-color', this.backupColor.categorie_font_color)
            this.document.style.setProperty('--cart-color', this.backupColor.cart_color)
            this.newColor = Util.deepCopy(this.backupColor)
        },
        apply: function () {
            Object.keys(this.newColor).forEach((e) => {
                this.config[e] = this.newColor[e]
            })
            this.config.isEditMode = false
            Util.setLocalVar('taaconfig', this.config)
            this.pallet = false
            this.$emit('closeEditMode')
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");
.pallet{
  position: absolute;
  bottom:622px;
  right:20px;
}
.pallet input{
  cursor: pointer;
  width: 150px;
  height: 100px;
  border: none;
  border-bottom: solid;
  border-width: 1px;
  font-size: 24px;
  background-color: white;
  padding: 0;
}
.pallet button.main{
  position: absolute;
  width: 100px;
  height: 100px;
  right: 0;
  bottom: 0;
  margin: 0;
  z-index: 2;
  img {
    width: 30px;
  }
}
.pallet-container {
    position: absolute;
    bottom: 70px;
    right: 0;
    margin:0 0 50px;
    width: 500px;
    z-index:10;
    background-color: whitesmoke;
    border-radius: 10px;
}
.pallet ul {
    margin: 10px 10px 1px;
}
.pallet ul li{
  display: flex;
  justify-content: flex-start;
  position: relative;
  height: 100px;
}
.pallet ul li label{
  color: black;
  white-space: nowrap;
  padding: 33px 10px;
  width: 350px;
  display: block;
  background-color: white;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  border-radius:3px;
  font-size: 25px;
  border-bottom: solid;
  border-width: 1px;
}
.button-default {
    width: 200px;
    height: 50px;
    display:inline-block;
    margin: 14px 20px;
}
.btn-outlined {
    margin-right: 34px;
}
.footer {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: whitesmoke;
}
.fade-enter-active {
  animation: enter-in 0.2s;
}
.fade-leave-active {
  animation: enter-in 0.2s reverse;
}
@keyframes enter-in {
  0% {
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 698px) { // Gertec SK210
    .pallet {
        bottom: 150px;
        input {
            width: 60px;
            height: 40px;
        }
        button.main{
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: 16px;
            }
        }
    }
    .pallet-container {
        bottom: 0;
        width: 300px;
    }
    .pallet ul li{
        height: 40px;
    }
    .pallet ul li label{
        padding: 10px 10px;
        width: 200px;
        border-radius: 3px 0 0 3px;
        font-size: 15px;
    }
    .button-default {
        width: 130px;
        margin: 10px;
    }
    .btn-outlined {
        margin-right: 0;
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .pallet{
        bottom: 300px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/EditMode.vue